import ShowMoreText from '../../../components/ShowMoreText'
import TagList from '../../../components/display/TagList'
import Tag from '../../../components/display/Tag'
import { normalizeKeys } from '../../../components/utils/propsUtils'

import { AdventureCardListDisplay } from '../Adventures/AdventureCardList'

import { Section, SubSection, SectionTitle } from './shared'

export default ({ listing }) => {
  if (
    !(
      (listing.adventures && listing.adventures.on_property.length > 0) ||
      (listing.outdoor_equipment && listing.outdoor_equipment.length > 0)
    )
  ) {
    return null
  }

  const onPropertyAdventuresEdges = listing.adventures.on_property?.map(
    (adventure) => {
      return {
        node: {
          ...normalizeKeys(adventure),
          storyteller: adventure?.storyteller && {
            ...normalizeKeys(adventure.storyteller),
            avatar: {
              thumbLg: adventure.storyteller.avatar_url,
            },
          },
        },
      }
    },
  )

  return (
    <Section>
      {listing.adventures.on_property.length > 0 && (
        <div>
          <SectionTitle>Adventures on the Property</SectionTitle>
          <SubSection intro>
            <p>
              These are the exclusive natural wonders and outdoor activities
              within the property boundaries.
            </p>
          </SubSection>

          <SubSection>
            <AdventureCardListDisplay
              adventureEdges={onPropertyAdventuresEdges}
            />
          </SubSection>
        </div>
      )}

      {listing.outdoor_equipment && listing.outdoor_equipment.length > 0 && (
        <div>
          <SectionTitle>Outdoor Equipment Provided</SectionTitle>
          <SubSection intro>
            <p>
              Enjoy the outdoors with the following equipment included in your
              stay.
            </p>
          </SubSection>

          <SubSection>
            <TagList>
              {listing.outdoor_equipment.map((eq) => (
                <Tag key={eq.id} icon={eq.slug} sunUp>
                  {eq.name} ({eq.quantity})
                </Tag>
              ))}
            </TagList>
          </SubSection>

          <ShowMoreText>{listing.outdoor_equipment_details}</ShowMoreText>
        </div>
      )}
    </Section>
  )
}
